import React from 'react';
import { ReactComponent as PlayIcon } from 'new/components/icons/fi-rr-play.svg';
import { ReactComponent as CheckIcon } from 'new/components/icons/fi-rr-check.svg';
import { ReactComponent as PauseIcon } from 'new/components/icons/fi-rr-pause.svg';
import { FlowRun } from 'new/components/monitor/Runs/components/FlowRunsTable/types';

import s from './FlowRunStatus.module.scss';

const flowRunStateConfig = {
  processing: {
    label: 'Running',
    icon: <PlayIcon />,
  },
  completed: {
    label: 'Completed',
    icon: <CheckIcon />,
  },
  failed: {
    label: 'Failed',
    icon: null,
  },
  idle: {
    label: 'IDLE',
    icon: <PauseIcon />,
  },
};

function FlowRunStatus({ row }: { row: FlowRun }) {
  if (!row) return null;

  const status = row.runtime_status?.toLowerCase();

  const label = status ? flowRunStateConfig[status]?.label : 'IDLE';
  const icon = status ? flowRunStateConfig[status]?.icon : null;

  return (
    <div className={s[`${status}Status`]}>
      {icon}
      <span className={s.label}>{label}</span>
    </div>
  );
}

export { FlowRunStatus };
